import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './globals.css'
import { STAGE } from '@/config'

// js-cache-storage: 提取常量到模块级别
const LOADING_FADE_DURATION = 300
const LOADING_TIMEOUT = 2000
const ROOT_ELEMENT_ID = 'root'
const LOADING_ELEMENT_ID = 'app-loading'

// 在应用启动的最早阶段初始化 VConsole，确保能捕获所有网络请求和日志
// 必须在任何网络请求发送之前初始化
if (STAGE !== 'production' && typeof window !== 'undefined') {
  // 同步初始化 VConsole，避免错过早期的网络请求
  import('vconsole')
    .then((module) => {
      const VConsoleLib = module.default
      // 初始化 VConsole 实例（不需要保存引用，VConsole 会自动挂载到 window）
      new VConsoleLib({
        theme: 'light',
        defaultPlugins: ['system', 'network', 'element', 'storage'],
        maxLogNumber: 1000,
      })
      console.log('[VConsole] 已启用，当前环境:', STAGE)
    })
    .catch((error) => {
      console.error('[VConsole] 加载失败:', error)
    })
}

// js-cache-property-access: 缓存 DOM 元素查询
const rootElement = document.getElementById(ROOT_ELEMENT_ID)
if (!rootElement) {
  throw new Error(`Element with id "${ROOT_ELEMENT_ID}" not found`)
}

const root = ReactDOM.createRoot(rootElement)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// React 渲染完成后移除 loading
// 使用 MutationObserver 检测 React 是否已挂载到 DOM
const removeLoading = () => {
  // js-cache-property-access: 缓存 DOM 查询
  const loading = document.getElementById(LOADING_ELEMENT_ID)
  // js-early-exit: 提前返回
  if (!loading) return

  // 先添加淡出类
  document.body.classList.add('app-loaded')
  // 等待淡出动画完成后移除元素
  setTimeout(() => {
    loading.remove()
  }, LOADING_FADE_DURATION)
}

// 检测 #root 是否有内容（React 已挂载）
const checkReactMounted = () => {
  // js-cache-property-access: 使用已缓存的 rootElement
  if (rootElement && rootElement.children.length > 0) {
    // React 已挂载，等待下一个渲染帧确保内容已渲染
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        removeLoading()
      })
    })
    return true
  }
  return false
}

// 立即检查一次（可能 React 已经挂载）
if (!checkReactMounted()) {
  // 如果还没挂载，使用 MutationObserver 监听
  const observer = new MutationObserver(() => {
    if (checkReactMounted()) {
      observer.disconnect()
    }
  })

  // js-cache-property-access: 使用已缓存的 rootElement
  observer.observe(rootElement, {
    childList: true,
    subtree: true,
  })

  // 设置超时保护，最多等待 2 秒后强制移除
  setTimeout(() => {
    observer.disconnect()
    removeLoading()
  }, LOADING_TIMEOUT)
}
